var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaceholderImage = function SvgPlaceholderImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#646464"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.094 100H3.906A3.906 3.906 0 0 1 0 96.094V3.906A3.906 3.906 0 0 1 3.906 0h92.188A3.906 3.906 0 0 1 100 3.906v92.188A3.906 3.906 0 0 1 96.094 100ZM3.906 1.562a2.39 2.39 0 0 0-2.344 2.344v92.188a2.39 2.39 0 0 0 2.344 2.344h92.188a2.391 2.391 0 0 0 2.344-2.344V3.906a2.39 2.39 0 0 0-2.344-2.344H3.906Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.594 99.516 30.5 44.188a2.453 2.453 0 0 0-3.36 0L1.314 70.125.219 69.031 26.047 43.11a4.016 4.016 0 0 1 5.547 0l55.094 55.329-1.094 1.078Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.672 86.438 68.094 55.733a2.33 2.33 0 0 0-1.672-.703 2.359 2.359 0 0 0-1.688.703L54.25 66.25l-1.125-1.078 10.516-10.484a3.953 3.953 0 0 1 4.278-.847 3.89 3.89 0 0 1 1.269.846l30.578 30.657-1.094 1.094ZM73.047 37.156a10.202 10.202 0 1 1 10.187-10.203 10.219 10.219 0 0 1-10.187 10.203Zm0-18.86a8.657 8.657 0 1 0 8.656 8.657 8.672 8.672 0 0 0-8.656-8.656Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v100H0z"
  })))));
};
export default SvgPlaceholderImage;